/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Img, Link, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import theme from "../helpers/theme";

export const NotFound = () => (
	<Box d="flex">
		<Box
			w="130%"
			height="100vh"
			backgroundColor={theme.colours.white}
			d="flex"
			flexDir="column"
			alignItems="center"
			justifyContent="center"
		>
			<Text fontSize="xl" mb="1rem">
				Sorry, we didn't find the page you're looking for. <br />
			</Text>
			<Link
				fontSize="xl"
				mb="3rem"
				textAlign="center"
				color="purple.400"
				as={RouterLink}
				to="/"
			>
				Go Home.
			</Link>
			<Img
				h="50vh"
				src="https://firebasestorage.googleapis.com/v0/b/kyoi-dev.appspot.com/o/Public%2F404.png?alt=media&token=930e1f55-ceb5-446c-b889-46132f49e677"
			/>
		</Box>
	</Box>
);
